(() => {
  const initialise = () => {
    const section = document.querySelector('[data-voltridge]');
    if (!section || section.dataset.ready) return;
    section.dataset.ready = 'true';
    const get = id => document.getElementById(id);
    const input = get('quantity');
    const normalise = () => {
      if (!input) return;
      input.value = Math.min(99, Math.max(1, parseInt(input.value, 10) || 1));
      get('minus').disabled = Number(input.value) <= 1;
      get('plus').disabled = Number(input.value) >= 99;
    };
    if (input) {
      get('minus').onclick = () => { input.value = Number(input.value) - 1; normalise(); };
      get('plus').onclick = () => { input.value = Number(input.value) + 1; normalise(); };
      input.addEventListener('change', normalise);
      normalise();
    }
    const thumbnails = Array.from(document.querySelectorAll('[data-image]'));
    thumbnails.forEach(button => {
      button.onclick = () => {
        document.querySelectorAll('[data-image]').forEach(other => {
          other.classList.toggle('selected', other === button);
          other.setAttribute('aria-pressed', String(other === button));
        });
        get('mainImage').src = button.dataset.image;
        if (button.dataset.srcset) get('mainImage').srcset = button.dataset.srcset;
        get('mainImage').alt = button.dataset.alt;
        get('galleryCounter').textContent = `${String(button.dataset.index).padStart(2, '0')} / 07`;
        const rail = button.parentElement;
        const left = button.offsetLeft - rail.offsetLeft;
        if (left < rail.scrollLeft) rail.scrollLeft = left;
        else if (left + button.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = left + button.offsetWidth - rail.clientWidth;
      };
    });
    let touchStart = null;
    get('mainImage').addEventListener('touchstart', event => {
      if (event.touches.length === 1) touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      else touchStart = null;
    }, { passive: true });
    get('mainImage').addEventListener('touchend', event => {
      if (!touchStart || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      const index = thumbnails.findIndex(button => button.classList.contains('selected'));
      thumbnails[Math.max(0, Math.min(thumbnails.length - 1, index + (dx < 0 ? 1 : -1)))].click();
    }, { passive: true });
    get('mainImage').addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
    get('zoom').onclick = () => {
      get('zoomImage').src = get('mainImage').src;
      get('zoomImage').alt = get('mainImage').alt;
      get('imageDialog').showModal();
    };
    document.querySelectorAll('[data-close]').forEach(button => {
      button.onclick = () => get(button.dataset.close).close();
    });
    const dialog = get('imageDialog');
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    const add = get('addToCart');
    const sticky = get('stickyBuy');
    const syncSticky = () => {
      const editing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
      const visible = Boolean(add && add.getBoundingClientRect().bottom < 0 && !editing);
      sticky.classList.toggle('visible', visible);
      sticky.inert = !visible;
      sticky.setAttribute('aria-hidden', String(!visible));
    };
    if (add) new IntersectionObserver(syncSticky).observe(add);
    syncSticky();
    document.addEventListener('focusin', syncSticky);
    document.addEventListener('focusout', () => requestAnimationFrame(syncSticky));
    const updateCountdown = () => {
      const timerApi = window.VoltRidgeDailyTimer;
      document.querySelectorAll('[data-sale-timer="daily"]').forEach(banner => {
        const seconds = timerApi?.secondsUntilNextMidnight(banner.dataset.timeZone || 'Australia/Brisbane');
        if (!Number.isFinite(seconds)) {
          banner.hidden = true;
          return;
        }
        banner.hidden = false;
        banner.querySelectorAll('[data-countdown]').forEach(clock => {
          clock.textContent = timerApi.format(seconds);
        });
      });
    };
    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    section.addEventListener('shopify:section:unload', () => clearInterval(timer), { once: true });
    document.addEventListener('visibilitychange', updateCountdown);
    const reveal = hash => {
      if (hash !== '#shipping' && hash !== '#guarantee') return;
      const details = document.querySelector(hash);
      if (details) details.open = true;
    };
    reveal(location.hash);
    window.addEventListener('hashchange', () => reveal(location.hash));
    document.querySelectorAll('a[href*="#shipping"],a[href*="#guarantee"]').forEach(link => {
      link.addEventListener('click', () => reveal(new URL(link.href).hash));
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

(() => {
 function setupReviewSlider(){
  const track=document.getElementById('reviewTrack');
  if(!track || track.dataset.ready) return;
  track.dataset.ready='true';
  const prev=document.querySelector('[data-review-prev]');
  const next=document.querySelector('[data-review-next]');
  const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
  const move=direction=>{const card=track.querySelector('.review-card');if(!card)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
  prev.onclick=()=>move(-1);next.onclick=()=>move(1);
  track.addEventListener('scroll',update,{passive:true});
  new ResizeObserver(update).observe(track);update();
 }
 setupReviewSlider();document.addEventListener('shopify:section:load',setupReviewSlider);
})();
